import styled, { css } from 'foundations-theming-specialty/utils';
import { keyframes } from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
const textInputBoxAnimation = ({
  disabled,
  from,
  to
}) => {
  const animation = keyframes(["from{background:", " !important;}to{background:", " !important;}"], from, to);
  if (!disabled) {
    return css(["animation:", " 1s ease-in !important;"], animation);
  }
  return css([""]);
};
const breezeButtonStyles = css(["display:flex;align-items:center;justify-content:center;margin:0 !important;height:", ";width:", " !important;min-width:", " !important;border:none !important;color:", " !important;background:", " !important;", ""], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.color['text-interactive-on-fill-default'], ({
  disabled,
  theme
}) => !disabled ? theme.color['breeze-fill-special-btn-alt-default'] : theme.color['breeze-fill-secondary-pressed'], ({
  disabled,
  theme
}) => textInputBoxAnimation({
  disabled,
  from: theme.color['breeze-fill-secondary-pressed'],
  to: theme.color['breeze-fill-special-btn-alt-disabled']
}));
export const BreezeButton = styled(UIIconButton).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "BreezeButton"
})(["", ""], breezeButtonStyles);